// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2747":"f8ecaa84","3151":"f8ecaa84"}[chunkId] + ".chunk.css";
};